import createIcon from '../../createIcon';

/**
 * @component @name PivotTableChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS41IDcuNUgyMC41VjQuNUMyMC41IDMuNCAxOS42IDIuNSAxOC41IDIuNUg5LjVWNy41Wk0yLjUgNy41SDcuNVYyLjVINC41QzMuNCAyLjUgMi41IDMuNCAyLjUgNC41VjcuNVpNNC41IDIwLjVINy41VjkuNUgyLjVWMTguNUMyLjUgMTkuNiAzLjQgMjAuNSA0LjUgMjAuNVpNMTIuNSAyMS41TDguNSAxNy41TDEyLjUgMTMuNVYyMS41Wk0xMy41IDEyLjVMMTcuNSA4LjVMMjEuNSAxMi41SDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQuMDggMTguNUgxMi41VjE2LjVIMTQuMDhDMTUuNDEgMTYuNSAxNi41IDE1LjQyIDE2LjUgMTQuMDhWMTIuNUgxOC41VjE0LjA4QzE4LjUgMTYuNTIgMTYuNTIgMTguNSAxNC4wOCAxOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PivotTableChart = createIcon('PivotTableChart', [
  [
    'path',
    {
      d: 'M9.5 7.5H20.5V4.5C20.5 3.4 19.6 2.5 18.5 2.5H9.5V7.5ZM2.5 7.5H7.5V2.5H4.5C3.4 2.5 2.5 3.4 2.5 4.5V7.5ZM4.5 20.5H7.5V9.5H2.5V18.5C2.5 19.6 3.4 20.5 4.5 20.5ZM12.5 21.5L8.5 17.5L12.5 13.5V21.5ZM13.5 12.5L17.5 8.5L21.5 12.5H13.5Z',
      key: '1ax05u',
    },
  ],
  [
    'path',
    {
      d: 'M14.08 18.5H12.5V16.5H14.08C15.41 16.5 16.5 15.42 16.5 14.08V12.5H18.5V14.08C18.5 16.52 16.52 18.5 14.08 18.5Z',
      key: 'x6uyn',
    },
  ],
]);

export default PivotTableChart;
